import { validate } from "./../validate";
import { uid } from "@dhx/ts-common/core";
import { el } from "@dhx/ts-common/dom";
import { IEventSystem } from "@dhx/ts-common/events";
import { PropertyEvents } from "../types";

export class Text {
	protected _uid: string;
	protected _config: any;
	protected _evs: IEventSystem<PropertyEvents>;
	protected _handlers: any;

	constructor(config: any, ev: IEventSystem<PropertyEvents>) {
		this._config = { ...config };
		this._evs = ev;
		this._uid = uid();

		this._handlers = {
			change: e => this._changed(e),
		};
	}
	setValue(value: any, silent?: boolean) {
		const old = this._config.value;
		if (value !== old) {
			this._config.value = value;
			this._config.invalid = !validate(value, this._config.validate);
			if (!silent) {
				this._evs.fire(PropertyEvents.change, [this._config.id, value, old]);
			}
		}
	}
	getValue() {
		return this._config.value;
	}
	clear() {
		this.setValue("", true);
	}
	toVDOM(view) {
		return el(".dhx_text_item", { _key: this._uid }, [
			el(".dhx_value", [
				el("input", {
					_ref: this._uid,
					type: "text",
					value: this._config.value,
					class: this._config.invaild ? "dhx_invalid" : "",
					onchange: this._handlers.change,
					oninput: this._handlers.change,
				}),
			]),
		]);
	}
	protected _changed(e) {
		this.setValue(e.target.value);
	}
}
